import React from "react";
import ModuleFilterItem from "../filter/ModuleFilterItem"
import { Box, Typography } from "@mui/material";

const ModuleList = React.memo(({ list, hwId, title }) => (
  <Box>
    {list && list.length > 0 && (
      <>
        <Box sx={{ bgcolor: "background.mid", pl: 2, py: 1 }}>
          <Typography>{title}</Typography>
        </Box>

        {list.map((item, index) => (
          <ModuleFilterItem
            hwId={hwId}
            key={`${hwId}-${item.valueName}`}
            selectedItem={item}
            isLast={index === list.length - 1}
          />
        ))}
      </>
    )}
  </Box>
));

export default ModuleList;
